import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector, Optional } from "@angular/core";
import { APP_CONFIG } from "@bca-shared/models/config";
import { IResponse } from "@bca-shared/models/response";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import { delay, filter, map } from "rxjs/operators";

@Injectable()
export class MockApiInterceptor implements HttpInterceptor {
  constructor(@Optional() private readonly _injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const { api } = environment;
    const { url } = request;

    return url.includes("assets")
      ? next.handle(request)
      : next
          .handle(
            request.clone({
              url: `./assets/api/mock-api.json`,
              method: "GET",
            }),
          )
          .pipe(
            filter(
              (event: HttpEvent<IResponse>) => event instanceof HttpResponse,
            ),
            map((response: HttpResponse<IResponse>) => {
              const config = this._injector.get(APP_CONFIG);
              const { api_url_bca, api_url_pasfoto, api_url_rio } = config;

              const strippedUrl = url
                .replace(api_url_bca, String())
                .replace(api_url_pasfoto, String())
                .replace(api_url_rio, String());

              const path = strippedUrl.split("?").shift();

              return response.clone({ body: response.body[path] });
            }),
            delay(
              api.randomizeDelayTime && api.delayTime
                ? Math.floor(Math.random() * api.delayTime + 1) + 150
                : api.delayTime,
            ),
          );
  }
}
